/* src/app/core/shared/components/toast-container/toast-container.component.css */
.toast-stack {
  position: fixed;
  top: 22px;
  right: 22px;
  z-index: 3000;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: min(380px, calc(100vw - 32px));
}
.app-toast {
  display: grid;
  grid-template-columns: 34px 1fr auto;
  gap: 12px;
  align-items: start;
  padding: 14px 14px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.16);
  animation: toastIn 180ms ease-out;
}
.toast-icon {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
}
.toast-title {
  font-size: 14px;
  font-weight: 800;
  color: #111827;
}
.toast-message {
  margin-top: 3px;
  font-size: 13px;
  line-height: 1.35;
  color: #64748b;
}
.toast-close {
  border: 0;
  background: transparent;
  color: #94a3b8;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}
.toast-close:hover {
  color: #475569;
}
.toast-success {
  border-color: #bbf7d0;
}
.toast-success .toast-icon {
  background: #dcfce7;
  color: #15803d;
}
.toast-error {
  border-color: #fecaca;
}
.toast-error .toast-icon {
  background: #fee2e2;
  color: #b91c1c;
}
.toast-warning {
  border-color: #fde68a;
}
.toast-warning .toast-icon {
  background: #fef3c7;
  color: #92400e;
}
.toast-info {
  border-color: #bfdbfe;
}
.toast-info .toast-icon {
  background: #dbeafe;
  color: #1d4ed8;
}
@keyframes toastIn {
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
/*# sourceMappingURL=toast-container.component.css.map */
